(()=>{
const clamp = (v,a=0,b=1)=>Math.max(a,Math.min(b,v));
const ease = v=>{v=clamp(v);return v*v*(3-2*v);};
const mix = (a,b,t)=>a+(b-a)*t;
function sample(keys,p){
  let i=0;while(i<keys.length-1&&keys[i+1][0]<=p)i++;
  const a=keys[i],b=keys[Math.min(i+1,keys.length-1)];
  const t=b[0]===a[0]?0:ease((p-a[0])/(b[0]-a[0]));
  return a.slice(1).map((v,j)=>mix(v,b[j+1],t));
}
// An independent, scroll-native story. No frozen film tracks or timelines.
// Poses: progress, x, height, depth, hand rotation (radians).
// GLB bore centres are 114.9 mm from each half's origin. The old 115.4 mm
// placement left opposing bores 1 mm apart and screw heads off-centre.
const HALF_OFFSET=.1149;
const L=-HALF_OFFSET,R=HALF_OFFSET,Y0=-.0444,Y1=.0002,Y2=.0448,Y3=.0894,Y4=.134;
const moduleTracks=[
  {id:'first-blank',part:'blank',u:1,reused:true,keys:[
    [0,L,Y0,0,0],[.19,L,Y0,0,0],[.215,L-.06,Y0,0,0],
    [.255,L-.06,Y0,.25,0],[.295,R,Y1,.25,Math.PI],
    [.35,R,Y1,.12,Math.PI],[.385,R,Y1,0,Math.PI],[1,R,Y1,0,Math.PI]]},
  {id:'opening-right-blank',part:'blank',u:1,keys:[
    [0,R,Y0,0,Math.PI],[.048,R,Y0,0,Math.PI],
    [.063,R+.065,Y0,0,Math.PI],[.082,R+.42,Y0,.12,Math.PI],
    [.105,1.9,Y0,.12,Math.PI],[1,1.9,Y0,.12,Math.PI]]},
  {id:'first-mini',part:'macmini1u',u:1,reused:true,keys:[
    [0,1.9,Y0,.12,0],[.085,1.9,Y0,.12,0],[.145,R,Y0,0,0],[1,R,Y0,0,0]]},
  {id:'mini-2u',part:'mac2u',u:2,keys:[
    [0,-1.9,-.0222,.12,0],[.28,-1.9,-.0222,.12,0],
    [.385,L,-.0222,0,0],[1,L,-.0222,0,0]]},
  {id:'second-blank',part:'blank',u:1,reusedFrom:.51,keys:[
    [0,-1.9,Y2,.08,0],[.43,-1.9,Y2,.08,0],[.515,L,Y2,0,0],
    [.59,L,Y2,0,0],[.62,L,Y2,.24,0],[.65,L,Y2,.24,0],
    [.68,L-.06,Y2,.24,0],[.70,L-.06,Y2,.46,0],
    [.745,R,Y4,.46,Math.PI],[.79,R,Y4,.24,Math.PI],
    [.865,R,Y4,.24,Math.PI],[.905,R,Y4,0,Math.PI],[1,R,Y4,0,Math.PI]]},
  {id:'network-1',part:'keystone',u:1,reusedFrom:.515,keys:[
    [0,1.9,Y2,.08,Math.PI],[.435,1.9,Y2,.08,Math.PI],[.515,R,Y2,0,Math.PI],
    [.59,R,Y2,0,Math.PI],[.62,R,Y2,.24,Math.PI],
    [.865,R,Y2,.24,Math.PI],[.905,R,Y2,0,Math.PI],[1,R,Y2,0,Math.PI]]},
  {id:'network-2',part:'keystone',u:1,keys:[
    [0,1.9,Y3,.24,Math.PI],[.715,1.9,Y3,.24,Math.PI],
    [.79,R,Y3,.24,Math.PI],[.865,R,Y3,.24,Math.PI],
    [.905,R,Y3,0,Math.PI],[1,R,Y3,0,Math.PI]]},
  {id:'studio-3u',part:'studio3u',u:3,keys:[
    [0,-1.9,.0892,.24,0],[.74,-1.9,.0892,.24,0],[.795,L,.0892,.24,0],
    [.865,L,.0892,.24,0],[.905,L,.0892,0,0],[1,L,.0892,0,0]]}
];
// Screw pose: progress, x, head height, depth, axial orientation, spin.
// Pairs keep the real 24/48mm axes and 4mm shafts. Every set travels axially clear.
const screwTracks=[
  {id:'lower-top',keys:[
    [0,0,-.0222,0,1,0],[.012,0,-.0222,0,1,0],
    [.042,0,.055,0,1,-25],[.188,0,.055,0,1,-25],[.30,0,.10,0,1,-25],
    [.39,0,.10,0,1,-25],[.42,0,.02225,0,1,0],[1,0,.02225,0,1,0]]},
  {id:'lower-bottom',keys:[
    [0,0,-1.5,0,-1,0],[.33,0,-1.5,0,-1,0],[.39,0,-.145,0,-1,0],
    [.42,0,-.06665,0,-1,25],[1,0,-.06665,0,-1,25]]},
  {id:'upper-top',keys:[
    [0,0,1.5,0,1,0],[.485,0,1.5,0,1,0],[.52,0,.145,0,1,0],
    [.548,0,.067,0,1,25],[.59,0,.067,0,1,25],[.62,0,.067,.24,1,25],
    [.646,0,.145,.24,1,0],[.73,0,.234,.24,1,0],[.80,0,.234,.24,1,0],
    [.837,0,.15585,.24,1,25],[.865,0,.15585,.24,1,25],
    [.905,0,.15585,0,1,25],[1,0,.15585,0,1,25]]},
  {id:'upper-bottom',keys:[
    [0,0,-1.5,.24,-1,0],[.775,0,-1.5,.24,-1,0],
    [.80,0,-.055,.24,-1,0],[.837,0,.02255,.24,-1,25],
    [.865,0,.02255,.24,-1,25],[.905,0,.02255,0,-1,25],[1,0,.02255,0,-1,25]]}
];
// Radius, elevation, azimuth, aim height, aim depth, roll.
// Camera movement is authored specifically for the website, per the new brief.
const cameraTrack=[
  [0,1.00,.42,-.24,.056,.03,0],
  [.20,1.00,.42,-.24,.056,.03,0],
  [.285,1.40,.52,-.28,.078,.08,0],
  [.35,1.27,.38,-.16,.052,.03,0],
  [.425,.84,.25,-.10,.052,0,0],
  [.46,1.30,.30,.12,.055,0,0],
  [.55,.91,.28,.18,.047,0,0],
  [.61,1.15,.42,.32,.052,.07,0],
  [.715,1.52,.51,.34,.085,.12,0],
  [.79,1.38,.34,.20,.074,.10,0],
  [.875,1.22,.33,.18,.085,.065,0],
  [.93,.98,.30,-.22,.070,0,0],
  [1,.95,.34,-.34,.070,0,-.025]
];
const paletteTrack=[[0, 0.94902, 0.94902, 0.94902], [0.2, 1.0, 1.0, 1.0], [0.43, 0.909804, 0.909804, 0.909804], [0.63, 0.945098, 0.945098, 0.945098], [0.89, 0.917647, 0.917647, 0.917647], [1, 1.0, 1.0, 1.0]];


const frameKeys=Array.from({length:1921},(_,i)=>i);
function frameAt(p){const target=p*1920;let low=0,high=frameKeys.length-1;while(low<high){const mid=(low+high)>>1;if(frameKeys[mid]<target)low=mid+1;else high=mid;}return low>0&&target-frameKeys[low-1]<frameKeys[low]-target?low-1:low;}
function frameRect(w,h,portrait,p=0){
  const ratio=portrait?.5:1.6,height=Math.max(h*1.12,w/ratio*1.06),width=height*ratio;
  const t=Math.max(0,Math.min(1,p)),e=t*t*(3-2*t);
  const focusY=portrait?.575+(.53-.575)*e:.65+(.54-.65)*e;
  // Overscan keeps the rendered frame's edges outside the viewport throughout exits.
  const x=Math.max(w-width,Math.min(0,w*.5-width*.48));
  const y=Math.max(h-height,Math.min(0,h*(portrait?.55:.59)-height*focusY));
  return {x,y,width,height};
}
class RenderPlayer {
  constructor(stage,onReady,onError){
    Object.assign(this,{stage,onReady,onError,wanted:0,shown:-1,direction:1,stride:1,epoch:0,active:true,dirty:true,paintPending:0});
    this.cache=new Map();this.blobs=new Map();this.loading=new Map();this.decoding=new Map();this.failed=new Set();this.attempts=new Map();this.chunks=new Set();this.decodeTimes=[];
    this.workerJobs=new Map();this.workers=[];this.workerId=0;
    if(typeof Worker!=='undefined')for(let i=0;i<2;i++){
      try{
        const worker=new Worker(this.workerUrl());
        worker.onmessage=({data})=>{const job=this.workerJobs.get(data.id);if(!job){data.bitmap?.close();return;}this.workerJobs.delete(data.id);data.error?job.reject(Error(data.error)):job.resolve(data);};
        worker.onerror=()=>{this.workers=this.workers.filter(w=>w!==worker);for(const [id,job] of this.workerJobs)if(job.worker===worker){this.workerJobs.delete(id);job.reject(Error('Frame worker unavailable'));}worker.terminate();};
        this.workers.push(worker);
      }catch(e){break;}
    }
    this.canvas=document.createElement('canvas');this.ctx=this.canvas.getContext('2d',{alpha:true});
    stage.setAttribute('aria-busy','true');stage.append(this.canvas);this.resize();this.seek(0);
  }
  bundleUrl(chunk){const template=this.portrait?this.stage.dataset.motionPortraitTemplate:this.stage.dataset.motionTemplate;return template.replace(/sc12-[dp]-000\.json/,`sc12-${this.portrait?'p':'d'}-${String(chunk).padStart(3,'0')}.json`);}
  workerUrl(){return this.stage.dataset.workerUrl;}
  workerTask(kind,payload){
    if(!this.workers.length)return Promise.reject(Error('No frame worker'));
    const id=++this.workerId,worker=this.workers[id%this.workers.length];
    return new Promise((resolve,reject)=>{this.workerJobs.set(id,{worker,resolve,reject});worker.postMessage({id,kind,...payload});});
  }
  async unpack(data){
    if(this.workers.length)try{return (await this.workerTask('unpack',{frames:data.frames})).blobs;}catch(e){if(this.destroyed)throw e;}
    const blobs=[];for(const encoded of data.frames){const raw=atob(encoded),bytes=new Uint8Array(raw.length);for(let k=0;k<raw.length;k++)bytes[k]=raw.charCodeAt(k);blobs.push(new Blob([bytes],{type:'image/webp'}));}
    return blobs;
  }
  async bitmap(blob){
    if(this.workers.length)try{return (await this.workerTask('decode',{blob})).bitmap;}catch(e){if(this.destroyed)throw e;}
    return createImageBitmap(blob);
  }
  resize(){
    const w=this.stage.clientWidth,h=this.stage.clientHeight;if(!w||!h)return;
    const portrait=w/h<1.15,dpr=Math.min(devicePixelRatio,portrait?2:1.5);if(w===this.w&&h===this.h&&dpr===this.dpr)return;
    const opening=frameRect(w,h,portrait);
    const decodeWidth=portrait?1024:2048;
    if(portrait!==this.portrait||decodeWidth!==this.decodeWidth){
      this.epoch++;this.portrait=portrait;this.shown=-1;this.painted=-1;
      for(const c of this.loading.values())c.abort();this.loading.clear();
      for(const b of this.cache.values())b.close();this.cache.clear();this.blobs.clear();this.chunks.clear();this.failed.clear();this.attempts.clear();
    }
    Object.assign(this,{w,h,dpr,decodeWidth});
    const lowMemory=(navigator.deviceMemory||4)<=2,bytes=this.decodeWidth*this.decodeWidth*(portrait?2:.625)*4;
    this.cacheLimit=Math.floor((lowMemory?80:portrait?128:160)*1024*1024/bytes);this.decodeLimit=lowMemory?2:3;this.ahead=Math.min(30,Math.max(3,this.cacheLimit-4));
    this.canvas.width=Math.round(w*dpr);this.canvas.height=Math.round(h*dpr);this.ctx.setTransform(dpr,0,0,dpr,0,0);this.ctx.imageSmoothingQuality='low';
    const poster=this.stage.querySelector('.render-poster'),img=poster?.querySelector('img');
    const source=poster?.querySelector('source');if(source)source.media=portrait?'all':'not all';
    if(img){poster.style.transform='none';Object.assign(img.style,{position:'absolute',objectFit:'fill',width:`${opening.width}px`,height:`${opening.height}px`,left:`${opening.x}px`,top:`${opening.y}px`});}
    this.dirty=true;this.schedulePaint();this.pump();
  }
  seek(p){
    if(this.destroyed)return;const position=Math.max(0,Math.min(1,p))*1920,index=frameAt(position/1920),delta=position-(this.framePosition??position);
    this.framePosition=position;
    if(Math.abs(delta)>.001)this.stride=Math.max(1,Math.min(32,Math.abs(delta)));
    if(index!==this.wanted){
      this.direction=Math.sign(index-this.wanted);this.wanted=index;
      const chunk=Math.floor(index/16);for(const [n,c] of this.loading)if(Math.abs(n-chunk)>5){c.abort();this.loading.delete(n);}
    }
    this.p=p;this.stage.dataset.progress=p.toFixed(5);this.select();this.pump();
  }
  candidates(){
    const a=[this.wanted];for(let n=1;n<=this.ahead;n++){
      const forward=Math.round((this.framePosition??this.wanted)+this.direction*n*this.stride),back=Math.round((this.framePosition??this.wanted)-this.direction*n*this.stride);
      if(forward>=0&&forward<frameKeys.length)a.push(forward);if(n<=2&&back>=0&&back<frameKeys.length)a.push(back);
    }return a;
  }
  pump(){
    if(this.destroyed||!this.active)return;const candidates=this.candidates(),base=Math.floor(this.wanted/16),total=Math.ceil(frameKeys.length/16),chunks=[base,base+this.direction,base+this.direction*2,base+this.direction*3,base-this.direction].filter(n=>n>=0&&n<total);
    // Adjacent batches keep network latency out of the frame-by-frame path.
    for(const n of chunks){if(this.loading.size>=4)break;if(!this.chunks.has(n)&&!this.loading.has(n)&&!this.failed.has(n))this.fetchChunk(n);}
    for(const i of candidates){if(this.decoding.size>=this.decodeLimit)break;if(this.blobs.has(i)&&!this.cache.has(i)&&!this.decoding.has(i))this.decode(i);}
    // Keep visited batches for reverse scrolling; preload a short runway, not the entire film.
    if(!navigator.connection?.saveData&&this.loading.size<4&&chunks.every(n=>this.chunks.has(n))){
      const total=Math.ceil(frameKeys.length/16),base=Math.floor(this.wanted/16);
      for(let d=1;d<=12;d++){const n=base+this.direction*d;if(n>=0&&n<total&&!this.chunks.has(n)&&!this.loading.has(n)&&!this.failed.has(n)){this.fetchChunk(n);break;}}
    }
    this.trim(candidates);
  }
  async fetchChunk(n){
    const c=new AbortController(),epoch=this.epoch;this.loading.set(n,c);
    try{
      const response=await fetch(this.bundleUrl(n),{signal:c.signal,cache:'force-cache',priority:Math.floor(this.wanted/16)===n?'high':'low'});
      if(!response.ok)throw Error(`Animation batch ${n}: ${response.status}`);const data=await response.json();
      if(this.destroyed||c.signal.aborted||epoch!==this.epoch)return;
      const blobs=await this.unpack(data);if(this.destroyed||c.signal.aborted||epoch!==this.epoch)return;
      for(let j=0;j<blobs.length;j++)this.blobs.set(data.start+j,blobs[j]);this.chunks.add(n);
    }catch(e){if(e.name!=='AbortError'&&!this.destroyed&&epoch===this.epoch){const attempt=(this.attempts.get(n)||0)+1;this.attempts.set(n,attempt);if(attempt>=3){this.failed.add(n);console.error(e);if(!this.ready&&n===Math.floor(this.wanted/16))this.onError(e);}}}
    finally{if(this.loading.get(n)===c)this.loading.delete(n);this.pump();}
  }
  async decode(index){
    const token={},epoch=this.epoch,started=performance.now();this.decoding.set(index,token);
    try{
      const bitmap=await this.bitmap(this.blobs.get(index));if(this.destroyed||epoch!==this.epoch){bitmap.close();return;}
      this.decodeTimes.push(performance.now()-started);if(this.decodeTimes.length>256)this.decodeTimes.shift();this.cache.set(index,bitmap);this.select();
    }catch(e){if(!this.destroyed&&epoch===this.epoch){this.blobs.delete(index);console.error(e);}}
    finally{if(this.decoding.get(index)===token)this.decoding.delete(index);this.pump();}
  }
  select(){
    let index=this.cache.has(this.wanted)?this.wanted:-1;
    if(index<0)for(const key of this.cache.keys()){
      if(this.direction>0?(key>this.wanted||key<this.shown):(key<this.wanted||(this.shown>=0&&key>this.shown)))continue;
      if(index<0||Math.abs(key-this.wanted)<Math.abs(index-this.wanted))index=key;
    }
    if(index>=0&&index!==this.shown){this.shown=index;this.schedulePaint();}
  }
  trim(candidates){
    const keep=new Set(candidates),sorted=[...this.cache.keys()].sort((a,b)=>Number(keep.has(a))-Number(keep.has(b))||Math.abs(b-this.wanted)-Math.abs(a-this.wanted));
    for(const i of sorted){if(this.cache.size<=this.cacheLimit)break;if(i!==this.shown&&i!==this.wanted){this.cache.get(i).close();this.cache.delete(i);}}
    this.stage.dataset.decodedFrames=String(this.cache.size);this.stage.dataset.bufferedFrames=String(this.blobs.size);
  }
  schedulePaint(){if(!this.paintPending&&this.active&&!this.destroyed)this.paintPending=requestAnimationFrame(()=>{this.paintPending=0;this.paint();});}
  paint(){
    const bitmap=this.cache.get(this.shown);if(!bitmap||this.destroyed)return;
    if(!this.dirty&&this.painted===bitmap)return;this.dirty=false;this.painted=bitmap;
    const rect=frameRect(this.w,this.h,this.portrait,this.shown/1920);
    this.ctx.clearRect(0,0,this.w,this.h);this.ctx.drawImage(bitmap,rect.x,rect.y,rect.width,rect.height);
    this.stage.dataset.frameRect=JSON.stringify(rect);
    this.stage.dataset.renderFrame=String(frameKeys[this.shown]/4);this.stage.dataset.sequenceFrames=String(frameKeys.length);
    this.stage.dataset.renderSource='Studio 2K continuous';
    this.stage.dataset.frameWorkers=String(this.workers.length);
    if(!this.ready){this.ready=true;this.stage.querySelector('.render-poster')?.remove();this.stage.setAttribute('aria-busy','false');this.onReady();}
  }
  setActive(active){
    if(this.active===active)return;this.active=active;
    if(active){this.schedulePaint();this.pump();}
    else{cancelAnimationFrame(this.paintPending);this.paintPending=0;}
  }
  destroy(){this.destroyed=true;this.epoch++;cancelAnimationFrame(this.paintPending);for(const c of this.loading.values())c.abort();for(const b of this.cache.values())b.close();for(const job of this.workerJobs.values())job.reject(Error('Player disposed'));this.workerJobs.clear();for(const worker of this.workers)worker.terminate();this.workers=[];this.cache.clear();this.blobs.clear();this.loading.clear();}
}

// Critically damped motion: velocity carries through wheel events, then settles without a bounce.
function advanceGlide(position,velocity,target,elapsedMs,reducedMotion=false){
  if(reducedMotion)return {position:target,velocity:0,moving:false};
  const dt=Math.min(50,Math.max(0,elapsedMs))/1000,omega=6.875;
  const error=position-target,decay=Math.exp(-omega*dt),travel=(velocity+omega*error)*dt;
  let next=target+(error+travel)*decay,speed=(velocity-omega*travel)*decay;
  if(next<0||next>1){next=Math.max(0,Math.min(1,next));speed=0;}
  const moving=Math.abs(target-next)>.000025||Math.abs(speed)>.0001;
  return moving?{position:next,velocity:speed,moving}:{position:target,velocity:0,moving:false};
}

function mount(root){if(root.dataset.mounted)return;root.dataset.mounted='true';const abort=new AbortController(),signal=abort.signal;const listen=(name,fn,opts={})=>window.addEventListener(name,fn,{...opts,signal});
const $=s=>root.querySelector(s),story=root,stage=$('#rack-stage'),sticky=$('.cinema-sticky');
const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
const copies=[...root.querySelectorAll('.scene-copy')],nav=[...root.querySelectorAll('.story-nav button')],reveals=[...root.querySelectorAll('.scroll-reveal')];
let player,pending=0,progress=0,target=0,range=1,start=0,ready=false,lastFrame=0,velocity=0;
function init(){
  player=new RenderPlayer(stage,()=>{
    ready=true;measure();progress=clamp((scrollY-start)/range);draw(progress);request();
    stage.dataset.rackReady='true';
  },()=>{
    stage.dataset.rackReady='error';
    stage.innerHTML='<p class="render-error">The animation couldn’t load. Refresh to try again, or <a href="#shop">explore the mounts</a>.</p>';
  });
  player.seek(clamp((scrollY-start)/range));
  const observer=new ResizeObserver(()=>{measure();request();});observer.observe(sticky);signal.addEventListener('abort',()=>observer.disconnect());
}
function measure(){story.style.setProperty('--sc-sticky-height',sticky.offsetHeight+'px');start=story.getBoundingClientRect().top+scrollY-(parseFloat(getComputedStyle(sticky).top)||0);range=story.offsetHeight-sticky.offsetHeight;if(player)player.resize();}
function draw(p){player.seek(p);}
const buildPanel=$('.sc-build-shop'),buildLink=buildPanel?.querySelector('.sc-build-primary'),buildDetail=buildPanel?.querySelector('.sc-build-detail'),parts=buildPanel?[...buildPanel.querySelectorAll('[data-part]')]:[];
const buildStages=[
 [0,'blank','Two blank halves. One modular 19″ rack. Swap individual halves as your equipment changes.'],
 [.12,'mini','Replace one blank half with a mount made for the Mac Mini. Keep the other half in your setup.'],
 [.35,'m4','Make room for the Mac Mini M4 with a 2U mount, while reusing the original 1U parts.'],
 [.50,'keystone','Add a row for network connections with an 8-port keystone panel and a blank half.'],
 [.79,'studio','Add a 3U Mac Studio mount alongside the smaller modules to grow the assembly.'],
 [.905,'studio','The complete 5U layout combines the M4, Mac Studio, Mac Mini, keystone and blank modules.']
];
let buildStage=-1;
function updateBuildShop(p){
 if(!buildPanel)return;
 let index=0;while(index<buildStages.length-1&&p>=buildStages[index+1][0])index++;
 if(index===buildStage)return;buildStage=index;
 const [,key,detail]=buildStages[index],part=parts.find(a=>a.dataset.part===key);
 buildDetail.textContent=detail;buildLink.href=part.href;buildLink.textContent='Shop the '+part.textContent.replace(' ↗','')+' ↗';
 parts.forEach(a=>{a.hidden=p<Number(a.dataset.start);});
 buildPanel.querySelector('details').hidden=index===0;buildPanel.dataset.stage=String(index);
}

function setCopy(p){
  updateBuildShop(p);
  for(const el of copies){
    const start=Number(el.dataset.enter),end=Number(el.dataset.exit),fade=.024,entering=clamp((p-start)/fade),exiting=clamp((p-(end-fade))/fade),opacity=ease(entering)*(1-ease(exiting)),isOpening=el.classList.contains('opening');
    const travel=(1-ease(entering))*65-ease(exiting)*(isOpening?150:70),scale=1;
    el.style.opacity=opacity;el.style.transform=`translate3d(0,${reduce?0:travel}px,0) scale(${reduce?1:scale})`;el.style.visibility=opacity>.002?'visible':'hidden';el.style.pointerEvents=opacity>.8?'auto':'none';el.setAttribute('aria-hidden',opacity<.5?'true':'false');
  }
  const words=p<.205?'1U':p<.448?'2U':p<.625?'3U':p<.9?'more.':'5U',backdrop=$('.scene-word');if(backdrop.textContent!==words)backdrop.textContent=words;
  // Background lettering stays fixed; only its chapter label changes.
  const c=sample(paletteTrack,p);sticky.style.backgroundColor=`rgb(${c.map(v=>Math.round(v*255)).join(',')})`;sticky.classList.toggle('dark',false);
  const labels=p<.11?['01 — Modular 1U system',0]:p<.20?['02 — Device-specific mounts',1]:p<.448?['03 — Expand to 2U',2]:p<.625?['04 — Adapt to 3U',3]:['05 — Combine to 5U',4];
  if($('#scene-label').textContent!==labels[0])$('#scene-label').textContent=labels[0];nav.forEach((b,i)=>{if(i===labels[1])b.setAttribute('aria-current','step');else b.removeAttribute('aria-current');});
  const bar=$('.story-progress>span');bar.style.width='100%';bar.style.transformOrigin='left';bar.style.transform=`scaleX(${p})`;$('.story-progress').setAttribute('aria-valuenow',String(Math.round(p*100)));
  const cue=$('#scroll-cue'),ending=p>.94?'end':'scroll';if(cue.dataset.cue!==ending){cue.dataset.cue=ending;cue.innerHTML=p>.94?'FIND YOUR NEXT PIECE <span aria-hidden="true">↓</span>':'SCROLL TO EXPLORE <span aria-hidden="true">↓</span>'; }
}
function revealPage(){
  if(scrollY+innerHeight*1.2<story.offsetTop+story.offsetHeight)return;
  for(const el of reveals){
    const rect=el.getBoundingClientRect(),entry=clamp((innerHeight-rect.top)/(innerHeight*.75)),title=el.querySelector('h2');if(title)title.style.transform=`translateY(${reduce?0:(1-ease(entry))*85}px)`;
    if(el.classList.contains('statement')){el.style.setProperty('--statement-scale',mix(.78,1,ease(entry)));el.querySelectorAll('.benefits>div').forEach((item,i)=>{const t=ease(clamp(entry*1.6-i*.17));item.style.transform=`translateY(${reduce?0:(1-t)*80}px)`;item.style.opacity=mix(.2,1,t);});}
    if(el.classList.contains('shop'))el.querySelectorAll('.product-card').forEach((item,i)=>{const r=item.getBoundingClientRect(),t=ease(clamp((innerHeight-r.top+100)/(innerHeight*.7)));item.style.transform=`translateY(${reduce?0:(1-t)*(70+i*25)}px)`;});
    if(el.classList.contains('custom'))el.querySelector('.custom-club').style.transform=`rotate(${mix(-25,14,entry)}deg) scale(${mix(.7,1,entry)})`;
  }
}
function tick(now){
  pending=0;if(document.hidden)return;const dt=Math.min(40,now-lastFrame||16);lastFrame=now;target=clamp((scrollY-start)/range);const glide=advanceGlide(progress,velocity,target,dt,reduce);progress=glide.position;velocity=glide.velocity;
  player.setActive(scrollY<story.offsetTop+story.offsetHeight);if(player.active)draw(progress);revealPage();if(player.active)setCopy(progress);if(glide.moving)request();else lastFrame=0;
}
function request(){if(!pending)pending=requestAnimationFrame(tick);}
listen('scroll',request,{passive:true});listen('resize',()=>{measure();request();});document.addEventListener('visibilitychange',()=>{player.setActive(!document.hidden);if(!document.hidden)request();},{signal});
nav.forEach(b=>b.addEventListener('click',()=>scrollTo({top:start+Number(b.dataset.progress)*range,behavior:reduce?'instant':'smooth'})));
measure();setCopy(0);init();

root.cleanup=()=>{player.destroy();abort.abort();cancelAnimationFrame(pending);};}
function boot(){document.querySelectorAll('.sc-scroll').forEach(mount);}boot();document.addEventListener('shopify:section:load',boot);document.addEventListener('shopify:section:unload',e=>e.target.querySelector('.sc-scroll')?.cleanup?.());})();